import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/Center/List',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/Center/Get',
    method: 'post',
    data: { id },
  })
}

export function createItem(data) {
  // console.log('createItem', data)

  return request({
    url: '/Center/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  // console.log('updateItem', data)

  return request({
    url: '/Center/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/Center/Delete',
    method: 'delete',
    data,
  })
}

export function fetchAll() {
  return request({
    url: '/Center/List',
    method: 'post',
    data: {
      page: 0,
      limit: 0,
    },
  })
}

export function ownCenterList() {
  return request({
    url: '/Center/OwnCenterList',
    method: 'post',
    data: {
      page: 0,
      limit: 0,
    },
  })
}
